import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { http } from '../../redux/http';
import { GetProductBucketCap } from '../../redux/constants/apiConstants';
import { Waiting } from '../../components';
import { toast } from 'react-toastify';
import { toolTip } from '../../utils/icons';
import { commaSeperator } from '../../utils/methods';
import { ImageUrl } from '../../utils/constants';
const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  
`;

const Card = styled.div`
  width: calc(25% - 15px);
  background: #FEFEFE;
  border-radius: 12px;
  border: 0.75px solid #DCDCDC;
  padding: 16px;
  box-sizing: border-box;
  position: relative;
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

const IconBox = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #052838;
  display: flex;
  align-items: center;
  justify-content: center;
  > img {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
  }
`;

const ProductName = styled.div`
  font-family: Lato;
  font-size: 16px;
  font-weight: 700;
  color: #184A61;
  flex: 1;
  margin-left: 12px;
`;

const TooltipWrapper = styled.div`
  position: relative;
  cursor: pointer;
  &:hover .tooltip-text {
    display: block;
  }
  .tooltip-text {
    display: none;
    position: absolute;
    right: -10px;
    top: 30px;
    background: #fefefe;
    color: #184a61;
    border: 0.75px solid #DCDCDC;
    font-size: 14px;
    font-family: Lato;
    padding: 10px 12px;
    border-radius: 6px;
    z-index: 10;
    width: 300px;
    white-space: normal;
    text-align: center;
    line-height: 18px;
    &::after {
      content: '';
      position: absolute;
      top: -20px;
      right: 8px;
      border-width: 10px;
      border-style: solid;
      border-color: transparent transparent #DCDCDC transparent;
    }
  }
`;



const Divider = styled.hr`
  border: none;
  border-top: 1px solid #DCDCDC;
  margin: 12px 0;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

const Label = styled.div`
  font-family: Lato;
  font-size: 16px;
  color: #184A61;
`;

const Value = styled.div`
  font-family: Lato;
  font-size: 16px;
  font-weight: 700;
  color: #184A61;
`;

class BucketCaps extends Component {
  constructor(props) {
    super(props);
    this.state = { data: null, loading: true };
  }
  isNoCap = (val) => val === '-' || val === 0 || val === '0' || val === 'NA' || val === 'N/A' || val === null || val === undefined || val === '';

  async componentDidMount() {
    const { rewardPeriodId, userId } = this.props;
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    try {
      const url = userId
        ? `${GetProductBucketCap}?reward_period_id=${rewardPeriodId}&uid=${userId}`
        : `${GetProductBucketCap}?reward_period_id=${rewardPeriodId}`;
      window.console.log('BucketCaps API URL:', url);
      const res = await http.get(url, { headers: { AUTHTOKEN: AuthToken } });
      this.setState({ data: res.buckets || [], loading: false });
    } catch (e) {
      toast.error(e.message);
      this.setState({ loading: false });
    }
  }





  render() {
    const { data, loading } = this.state;
    if (loading) return <Waiting />;
    if (!data || !data.length) {
      return <div style={{ padding: '20px', color: '#989898', fontFamily: 'Lato' }}>No bucket cap data available.</div>;
    }

    
    const withCap = data.filter((item) => !this.isNoCap(item.bucket_cap));
    const withoutCap = data.filter((item) => this.isNoCap(item.bucket_cap));
 

    const renderCard = (item, i, tooltipText, isWithoutCap) => (
      <Card key={i}>
        <CardHeader>
          <IconBox>
            {item.icon
              ? <img src={`${ImageUrl}/${item.icon}`} alt={item.product_name} />
              : <span style={{ color: '#fff', fontFamily: 'Lato', fontSize: '16px', fontWeight: '700' }}>
                {item.product_name?.charAt(0)}
              </span>
            }
          </IconBox>

          {/* <IconBox>
            {item.icon 
              ? <img src={`${ImageUrl}/${item.icon}`} alt={item.product_name} /> 
              : <span style={{ color: '#fff', fontFamily: 'Lato', fontSize: '16px', fontWeight: '700' }}>{item.product_name?.charAt(0)}</span>
            }
          </IconBox> */}
          <ProductName>{item.product_name}</ProductName>
          {item.product_name === 'Fitness' ? (
            <TooltipWrapper>
              {toolTip()}
              <div className="tooltip-text">
                This bucket includes points earned from: Device Minutes Log, Calories (1 point per 100), Steps (1 point per 1,000), Manual Workout Logs, Setting Monthly Goals, Syncing a Fitness Device, Adding Monthly Goals, and starting a Wellness Adventure.
              </div>
            </TooltipWrapper>
          ) : (
            <TooltipWrapper>
              {toolTip()}
              <div className="tooltip-text">{tooltipText}</div>
            </TooltipWrapper>
          )}
        </CardHeader>
        <Divider />
        <div style={{ background: '#F8F8F8', padding: '8px', borderRadius: '4px' }}>
          <Row>
            <Label>Total Points Earned</Label>
            <Value>{this.isNoCap(item.total_points_earned_without_cap) ? item.total_points_earned_without_cap : `${commaSeperator(item.total_points_earned_without_cap)} XP`}</Value>
          </Row>
          {!isWithoutCap && (
            <Row>
              <Label>Bucket Cap</Label>
              <Value>{this.isNoCap(item.bucket_cap) ? item.bucket_cap : `${commaSeperator(item.bucket_cap)} XP`}</Value>

            </Row>
          )}
        </div>
      </Card>
    );

    return (
      <div>
        {withCap.length > 0 && (
          <>
            <div style={{ fontFamily: 'Lato', fontSize: '18px', color: '#184A61', fontWeight: '700', marginBottom: '20px' }}>
              Product Bucket Cap
            </div>
            <Grid>
              {withCap.map((item, i) => renderCard(item, i, "You'll receive points based on the bucket cap not the total points earned within a specific module."))}
            </Grid>
          </>
        )}
        {withoutCap.length > 0 && (
          <>
            <div style={{ fontFamily: 'Lato', fontSize: '18px', color: '#184A61', fontWeight: '700', margin: '20px 0 20px' }}>
              Product Without Bucket Cap
            </div>
            <Grid>
              {withoutCap.map((item, i) => renderCard(item, i, 'There is no bucket cap set for this product.'))}
            </Grid>
          </>
        )}
      </div>
    );
  }


}

BucketCaps.propTypes = {
  rewardPeriodId: PropTypes.number,
  userId: PropTypes.number, 
};

export default BucketCaps;
